import { client } from "~/utils/medproSDK";
import axios from "axios";
import { deleteKeyCookie } from "./func";

export const handleUnAuthorize = () => {
  // Xóa Cookies
  deleteKeyCookie("token");
  deleteKeyCookie("refreshToken");

  // Xóa LocalStorage
  window.localStorage.removeItem("jwt");

  // Reset SDK token
  if (client) {
    client.setToken("");
  }

  // Xóa headers Authorization
  if (axios.defaults.headers.common) {
    delete axios.defaults.headers.common.Authorization;
  }

  // Phát một sự kiện toàn cục để SPA Root component bắt được và điều hướng mượt mà
  const event = new CustomEvent("unauthorized-logout");
  window.dispatchEvent(event);
};
